// extracted by mini-css-extract-plugin
module.exports = {"link":"Link_link__uqKbV"};